<template>
  <header class="app-header border-solid flex items-center z-50">
    <div class="c-nav__header z-50 flex items-center">
      <a
        @click="isClosed = !isClosed"
        class="text-gray-800 w-full cursor-pointer hidden"
        ><svg viewBox="0 0 20 20" fill="currentColor" class="menu w-6 h-6">
          <path
            fill-rule="evenodd"
            d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
            clip-rule="evenodd"
          ></path></svg
      ></a>
      <img src="/img/logo.png" alt="GetChange Logo" style="width: 150px;" />
    </div>
    <div class="flex items-center ml-auto">
      <dropdown class="block mt-4 md:inline-block md:mt-0 pb-6 md:pb-0">
        <!-- Button content -->
        <template v-slot:button>
          <span
            class="hidden md:block h-8 w-8 rounded-full bg-gray-500 mr-1"
          ></span>
          <span class="mr-2 text-sm inline-block pl-2">Hi, Joshua</span>
          <svg
            viewBox="0 0 20 20"
            fill="currentColor"
            class="chevron-down animate-bounce w-4 h-4"
          >
            <path
              fill-rule="evenodd"
              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
              clip-rule="evenodd"
            ></path>
          </svg>
        </template>

        <!-- Opened dropdown content -->
        <template v-slot:content>
          <router-link
            class="block px-4 py-2 text-gray-800 hover:bg-gray-100"
            to="/register"
          >
            Logout
          </router-link>
        </template>
      </dropdown>
    </div>
  </header>
</template>

<script>
import Dropdown from "../../../components/Dropdown";
export default {
  name: "Header",
  components: {
    Dropdown
  }
};
</script>

<style lang="postcss" scoped>
.app-header {
  @apply bg-white relative flex justify-between px-2 border-b border-gray-300;
  height: 80px;
  width: 100%;
  position: fixed;
}
</style>
